import React from 'react'
import Header from "../../../../Components/Header";
import Contact from './Contact';
import { Helmet } from 'react-helmet';
function CreateContact() {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Contact - Create</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
                <Contact/>
            </div>
       </div>
  )
}

export default CreateContact
